import actionTypes from 'SRC/modules/redux/actionTypes'

export const resetPhotos = payload => ({
  type: actionTypes.RESET_AD_PHOTOS,
  payload
})
